/**
 * Fordons-id från API kan vara tal eller text (BIGINT). Jämför alltid som tal.
 */

export function toVehicleId(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function normalizeVehicleIds(values: unknown[]): number[] {
  const ids: number[] = [];
  for (const value of values) {
    const id = toVehicleId(value);
    if (id != null) ids.push(id);
  }
  return ids;
}

export function vehicleMatchesIdList(vehicleId: unknown, ids: Array<number | string> | null): boolean {
  if (ids === null) return true;
  const id = toVehicleId(vehicleId);
  if (id == null) return false;
  return ids.some((candidate) => toVehicleId(candidate) === id);
}
